import React from "react";
import Slider from "react-slick";
import "./Newhome.css";

const Fullbanner = () => {
  const settings = {
    dots: true,
    arrows: false,
    infinite: true,
    autoplay: true,
    speed: 900,
    autoplaySpeed: 4000,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  return (
    <div className="full_banner banner">
      <Slider {...settings}>
        <div className="slide_item">
          <img src="/images/u-winbanner.png" className="banner_image" />
        </div>

        <div className="slide_item">
          <img src="/images/sathsecondbanner.png" className="banner_image" />
        </div>

        <div className="slide_item">
          <img src="/images/ncdbanner.png" className="banner_image" />
        </div>

        <div className="slide_item">
          <img src="/images/jananibanner.png" className="banner_image" />
        </div>
        <div className="slide_item">
          <img src="/images/Tbfullbanner.png" className="banner_image" />
        </div>
        <div className="slide_item">
          <img src="/images/pmndpbannner.png" className="banner_image" />
        </div>
      </Slider>
    </div>
  );
};

export default Fullbanner;